import Api from "../../Api";

export const createReportDownload = async (request) => {
  try {
    let res = await Api.post("/report-downloads", request);
    return res?.data || {};
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const getReportDownloads = async (query) => {
  try {
    let res = await Api.get("/report-downloads", { params: query });
    return res?.data || { data: [], count: 0 };
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const downloadReportFile = async (id) => {
  const res = await Api.get(`/report-downloads/${id}/file`, { responseType: "blob" });
  return res.data;
};
